

import Vue from 'vue'
import App from './App.vue'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

let mainApp = null;


import '@/directives/index'

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    rail: {
      opacity: 0.6,
      background: '#4b0c08',
      size: '6px',
      gutterOfSide: '0px',
    },
    bar: {
      background: '#ad9152',
      keepShow: true,
      size: '6px',
    }
  }, // 在这里设置全局默认配置
  name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll 
});

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入样式
//import 'swiper/css/swiper.css'

//引入样式
// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css'

Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */ )

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

import {
  apiUserinfo,
  apiTaskinfo,
  apiScorenfo,
  apiTaskApply,
} from '@/api/index';
import {
  token_type,
  issn,
} from '@/api/config';

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL
Vue.prototype.$queryArea = GLOBAL.queryArea;

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//store
import store from "@/assets/js/store.js";
Vue.prototype.$store = store;

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;


//FREE
import Free_login from '@/assets/js/freeLogin.js';
import inviteFlow from '@/assets/js/inviteFlow';

//login
import esPassport from "@/assets/js/espassport.esm.min";
Vue.prototype.$mslogin = esPassport;
esPassport.init({
  loginUrl: GLOBAL.ajax_url_map.login, // 登录服务端接口地址（必填）
  redirectUrl: GLOBAL.domain // 登录成功后的回调地址（必填）
});

//cntDownTimer
import cntdownTimer from '@/components/cntdownTimer.vue'
Vue.component('cntdown-timer', cntdownTimer);

//user_info
import User_info from '@/components/userinfo.vue';
Vue.component('user-info', User_info);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem);

//rb pass
import rbPass from '@/components/rb.pass.vue'
Vue.component('rb-pass', rbPass);

//utils
import utils from '@/utils/index.js';
Object.keys(utils).forEach(key => {
  Vue.prototype[key] = utils[key]
})

Vue.prototype.$update_evt = function (data) {
  mainApp.user_init();
};

Vue.prototype.$task_render = function (data) {
  mainApp.task_init();
};

Vue.prototype.$hb_render = function (data) {
  mainApp.$refs.app.$refs.hb.init();
};


Vue.prototype.$task_apply = function (data) {
  mainApp.task_apply(data);
};

const preventScroll = function(e) {
    e.preventDefault();
}

// 禁止滚动
function disableScroll() {
    document.addEventListener('touchmove', preventScroll, false);
}

// 恢复滚动
function enableScroll() {
    document.removeEventListener('touchmove', preventScroll, false);
}

Vue.prototype.$disableScroll = disableScroll;
Vue.prototype.$enableScroll = enableScroll;


Vue.prototype.$calc_phase_by_arr = function(arr, val) {
    let phase = 0;
    for(let i = 0; i < arr.length; i++) {
        if(val >= arr[i]) phase = i + 1;
    }
    return phase;
};

  mainApp = new Vue({
    el: '#app',
    components: {
      App
    },
    template: '<App ref="app" :ready="ready"/>',
    data() {
      return {
        ua: {},
        evt_info: {},
        code: '',
        name: null,
        login: 0, //登陆
        aid: 0, //大区id
        account_type: 'pc',
        isLoading: false,
        ready: false, //通信阀门
        share_id: 'ME21',
        key: '',
        share: '',
        token: '',
      }
    },
    created() {
      var _this = this;

      let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem(token_type);
      _this.token = token;

      let urlCode = GLOBAL.getQueryVariable('code');
      let flow = inviteFlow.get();
      if(urlCode)inviteFlow.resetIfCodeMismatch(urlCode);
      flow = inviteFlow.get();
      let code = urlCode || (flow && flow.code) || localStorage.getItem("code");

      this.share = GLOBAL.getQueryVariable('share') || localStorage.getItem("share");
      if (GLOBAL.getQueryVariable('share')) {
        localStorage.setItem('share', this.share);
      }

      if (GLOBAL.getQueryVariable('code')) {
        this.$store.commit("$_setCode", GLOBAL.getQueryVariable('code'));
        localStorage.setItem('code', code);
      }

      this.key = code;

      if (token) {
        localStorage.setItem(token_type, token);
        _this.$store.commit("$_setToken", token);
      }

      window.history.pushState({}, 0, GLOBAL.domain);
    },
    mounted() {
      this.get_user_info();
      let url = GLOBAL.domain.indexOf('http') < 0 ? 'https:' + GLOBAL.domain : GLOBAL.domain;
      wx.wxInit({
        title: GLOBAL.wx_share_text.title, // 分享标题
        desc: GLOBAL.wx_share_text.desc, // 分享描述
        link: url, // 分享链接
        imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
      });

      //
    },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        this.ua.uid = this.ua.uid || 0;

        Free_login.free_login_lazy(
          this.$store.state.userinfo.accountid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
            wx: ajax_url_map.wx,
            issn: issn,
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
              localStorage.setItem(token_type, _this.token);
              _this.$store.commit("$_setToken", _this.token);
            }
            _this.user_init();

          }
        );
      },
      user_init() {

        const resumeInviteFlow = () => {
          const flow = inviteFlow.get();
          if(flow && flow.stage === 'bind_pending'){
            return this.$bind_modal({
              specialInviteFlow: true,
              inviteFlowId: flow.flowId,
              inviteCode: flow.code,
            });
          }
          if(flow && flow.stage === 'login_pending'){
            if(!this.$store.state.userinfo.zid){
              inviteFlow.setStage(flow.flowId, 'bind_pending');
              return this.$bind_modal({
                specialInviteFlow: true,
                inviteFlowId: flow.flowId,
                inviteCode: flow.code,
              });
            }

            inviteFlow.setStage(flow.flowId, 'invite_ready');
            this.key = flow.code;
            localStorage.setItem('code', flow.code);
            return this.$invite_apply({code : flow.code});
          }
          if(flow && flow.stage === 'invite_ready'){
            this.key = flow.code;
            localStorage.setItem('code', flow.code);
            return this.$invite_apply({code : flow.code});
          }
          if(flow && flow.stage === 'invite_after_bind'){
            this.key = flow.code;
            localStorage.setItem('code', flow.code);
            return this.$invite_apply({code : flow.code});
          }
          if(flow && flow.stage === 'welcome_pending' && flow.next === 'invite'){
            return this.$welcome_modal({
              onClose: () => {
                inviteFlow.setStage(flow.flowId, 'invite_after_bind');
                this.$update_evt();
              },
            });
          }
          if(flow && flow.stage === 'welcome_pending' && flow.next === 'done'){
            return this.$welcome_modal({
              onClose: () => inviteFlow.clear(flow.flowId),
            });
          }

          if(localStorage.getItem("code"))return this.$invite_apply({code : this.key});
          if(localStorage.getItem("share"))return this.$web_apply({code : this.share});
        };

        apiUserinfo().then(
          res => {
            this.$store.commit("$_setUserinfo", res.data);
            this.$store.commit("$_setLogin", 1);

            //apiScorenfo();

            const pay_lv = this.pay_level(res.data.payRmb);
            console.log(res.data.payRmb, pay_lv);
            this.$store.commit("$_setPayLevel", pay_lv);

            this.task_init();

            return resumeInviteFlow();

          },
          rej => {
            //this.ready = true;
            this.task_init();

            if (rej.code != 401 && rej.code != 402) this.$toast(rej.message);

            if (rej.data) {

              this.$store.commit("$_setUserinfo", rej.data);
              this.$store.commit("$_setLogin", 1);
            }
            
            const resumed = resumeInviteFlow();
            if(resumed)return resumed;
            if (rej.code == 402 && !localStorage.getItem("code")) {
              return this.$bind_modal();
            }

          },
        );

      },
      task_init() {
        //this.ready = true;
        apiTaskinfo({s : true}).then(
          res => {
            this.ready = true;
            this.$store.commit("$_setTask", res.data);
          },
          rej => {
            this.ready = true;
          }
        )
      },
      task_apply(orderId , cb) {

        if(!this.$store.state.login)return this.$mslogin.login();
        if(!this.$store.state.userinfo.zid)return this.$bind_modal();
        if(!orderId)return this.$toast('参数错误！');

        if(!Array.isArray(orderId))orderId = [orderId];
        orderId = orderId.filter(Boolean);
        if(!orderId.length)return this.$toast('参数错误！');

        apiTaskApply({OrderId : orderId}).then(
          res => {
            this.$msg_modal({ type : 'apply-success'});
            if(cb)cb();
            this.task_init();
          },
          rej => {
            this.$msg_modal(rej.message || '请稍后再试~');
          }
        )
      },
      pay_level(pay){
        let lv = 0
        switch (true) {
          case 0 <= pay && pay < 100:
            lv = 1;
            break;
          case 100 <= pay && pay < 5000:
            lv = 2;
            break;
          case 5000 <= pay:
            lv = 3;
            break;
        }
        return lv;
      },
    },
  })
